"use client";
import React from "react";
import clsx from "clsx";
import Image from "next/image";

export default function FeaturesSplit({ data }) {
  const {
    title,
    subtitle,
    features = [],
    align = "left",
    background = {},
    extra = {},
  } = data || {};

  const bgStyle =
    background.type === "gradient"
      ? { backgroundImage: background.value }
      : background.type === "color"
        ? { backgroundColor: background.value }
        : background.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "enter",
            }
          : {};

  const alignClass =
    align === "center"
      ? "text-center"
      : align === "right"
        ? "text-right"
        : "text-left";

  const image = extra?.image;

  return (
    <section className="py-20 px-4" style={bgStyle}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {image?.enabled && image?.position === "left" && (
          <div className="w-full relative aspect-4/3">
            <Image
              src={image.src}
              alt={image.alt || "alt"}
              fill={true}
              sizes="(max-width: 640px) 50vw, (max-width: 1200px) 30vw, 20vw"
              className="w-full h-auto rounded-lg object-cover"
            />
          </div>
        )}

        <div>
          {title && (
            <h2 className={clsx("text-3xl font-bold", alignClass)}>{title}</h2>
          )}
          {subtitle && (
            <p className={clsx("text-gray-600 mt-2", alignClass)}>{subtitle}</p>
          )}

          <div className="mt-8 space-y-6">
            {features.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4">
                {item.icon && <div className="text-2xl">{item.icon}</div>}
                <div>
                  <h3 className="font-semibold text-lg">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                  {item.link?.href && (
                    <a
                      href={item.link.href}
                      className="text-blue-600 hover:underline text-sm mt-1 inline-block"
                    >
                      {item.link.text || "Learn more"}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {image?.enabled && image?.position === "right" && (
          <div className="relative aspect-4/3">
            <Image
              src={image.src}
              alt={image.alt}
              fill={true}
              sizes="(max-width: 640px) 50vw, (max-width: 1200px) 30vw, 20vw"
              className="w-full rounded-lg object-cover"
            />
          </div>
        )}
      </div>
    </section>
  );
}
